import "./BookingDialog.scss";
import { Dialog, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import {API_RESPONSE, COMMON_CONSTANTS, NUMBER_CONSTANTS, TOASTER_CONFIGS } from "../../Utilities/Constants/Constants";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";
import { toast } from "react-toastify";
import { axiosInstance } from "../../Services/Interceptor/Interceptor";
import moment from "moment";
import { useParams } from "react-router-dom";

const BookingDialog = (props:any) => {
     const [ deleteType, setDeleteType ]= useState("");
     const [ reasonText, setReasonText ]= useState("");
     const [ reasonTouched, setReasonTouched ] = useState(API_RESPONSE.FALSE);
     const { id, role } = useParams();
     const [ payloads , setPayloads ] = useState<any>("")
     const [ roleId, setRoleId ]= useState<number>(role ? +role : 1);
     const [ userList, setUserList] = useState<any>([])
     /* Dialog close function */
     const onClose = () => {
       return props.onCloseDialog();

      };

      
    /* Setting type of delete event */
    const setDelType = (event:any)=>{
      setDeleteType(event.target.value);
    }

    useEffect(()=>{
      getApiCall(props.payload)
    },[])

    /*get the users list api call */
    const GetUsersListApi = (slotData:any) => {
      let startDate=  moment(slotData.start).format(COMMON_CONSTANTS.YMD_FORMAT);
      let endDate = moment(slotData.end).format(COMMON_CONSTANTS.YMD_FORMAT)
      axiosInstance.get(API_END_POINTS.GET_USER_LIST +
        "?service_session_id=" + slotData.service_provider_id +
       "&teach_service_id=" + roleId +
         "&start_date=" + startDate +
         "&end_date=" + endDate +
         "&start_time=" + slotData.start_time +
         "&end_time=" + slotData.end_time +
         "&session_title=" + slotData.title
        )
      .then((res:any)=>{
        if(res.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          // console.log(res.data)
          setUserList(res.data.result.data)
        }
      })
    }

    /* Delete slot API call */
    const deleteApiCall = (slotData:any, event:any) => {
      let startDate=  moment(slotData.start).format(COMMON_CONSTANTS.YMD_FORMAT);
      let endDate = moment(slotData.end).format(COMMON_CONSTANTS.YMD_FORMAT)
      axiosInstance.delete(API_END_POINTS.DELETE_SESSION +
         "?service_session_id=" + slotData.service_provider_id +
        "&teach_service_id=" + roleId +
          "&start_date=" + startDate +
          "&event_type=" + deleteType +
          "&end_date=" + endDate +
          "&start_time=" + slotData.start_time +
          "&end_time=" + slotData.end_time +
          "&reason=" + reasonText
          )
          .then((response:any)=>{
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
              toast.success(response.data.message, TOASTER_CONFIGS);
              onClose();
            }
          })
        .catch(()=>{})
    };

    const cancelApiCall = (slotData:any, event:any) => {
      let startDate=  moment(slotData.start).format(COMMON_CONSTANTS.YMD_FORMAT);
      let endDate = moment(slotData.end).format(COMMON_CONSTANTS.YMD_FORMAT)
      let payload = {
        "service_session_id":  slotData.service_provider_id ,
        "teach_service_provider_id" : role,
          "start_date" : startDate,
          "event_type" : deleteType,
          "end_date" : endDate,
          "start_time": slotData.start_time,
          "end_time": slotData.end_time,
          "reason" : reasonText
      }
      axiosInstance.post(API_END_POINTS.DELETE_SESSION, payload)
      .then((response:any)=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          onClose();
        }
      })
      .catch(()=>{})
    }

    const getApiCall = (slotData:any) => {
      axiosInstance.get(API_END_POINTS.GET_SESSION_DETAILS +
         "?service_session_id=" + slotData.service_session_id +
         "&teach_service_id=" + slotData.teach_service +
         "&slot_id=" + slotData.slot_id +
         "&timeslot_id="+ slotData.timeslot_id)
         .then((response:any) => {
          if(response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            toast.success(response.data.message, TOASTER_CONFIGS);
            setPayloads(response.data.result.data)
            GetUsersListApi(response.data.result.data)
          }
         })
    }

    /* Delete slot payload based on roleId */
    const onDelCategory = () => {
       setReasonTouched(API_RESPONSE.TRUE);
       if(reasonText.trim() !== ''){
       if(roleId===1){
          deleteApiCall(payloads,payloads.tutor_session);
        }else if(roleId===2){
          deleteApiCall(payloads,payloads.personaltrainer_session);
        }else if(roleId===3){
          deleteApiCall(payloads,payloads.recreationalcamp_session);
        }
       }else {
          toast("Give The Reason")
       }
    };


    const onCancel = () => {
        setReasonTouched(API_RESPONSE.TRUE);
       if(reasonText.trim() !== ''){
       if(roleId===1){
          cancelApiCall(payloads,payloads.tutor_session);
        }else if(roleId===2){
          cancelApiCall(payloads,payloads.personaltrainer_session);
        }else if(roleId===3){
          cancelApiCall(payloads,payloads.recreationalcamp_session);
        }
       }else {
          toast("Give The Reason")
       }
    }
      
    return(
        <div className="delete-dialog-wrapper">
      <Dialog
        className="delete-dialog"
        open={props.openStatus}
        sx={{ "& .MuiDialog-paper": "cus-dialog" }}
      >
        <DialogTitle className="title-wrap">
          <h5 className="title">{"Cancel recurring event"}</h5>
          <div>
          <CloseIcon className="close-icon" onClick={onClose} />
          </div>
        </DialogTitle>

        <DialogContent>
            <div>
                {userList.map((data:any , i:any)=>{
                  return <li key={data.id}>{`${data.firstname} ${data.lastname}`}</li>
                })}
                {userList.length === 0 && <li>No user Found</li> }
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={setDelType}
                >
                <FormControlLabel value={`${NUMBER_CONSTANTS.ONE}`} control={<Radio />} label="Cancel this event" />
            </RadioGroup>
           {deleteType &&  <div>
              <p className="reason-label">Reason for cancel:</p>
              <textarea 
              rows={3} 
              className="reason-textbox"
              onChange={(e:any)=>{ setReasonText(e.target.value);}}
              onBlur={() => {
                setReasonTouched(API_RESPONSE.TRUE);
              }}
              />
              { reasonTouched && reasonText==='' && <p className="reason-text">{"Please enter the reason"}</p>}
            </div>}
            <div className="dialog-btn-wrapper">
                <button className="btn cancel-btn"  onClick={onCancel}>Cancel The Slot</button>
                <button className="btn btn-danger" onClick={onDelCategory}>Delete The slot</button>
            </div>
            </div>
            
        </DialogContent>
        </Dialog>
        </div>
    )
};

export default BookingDialog;